export enum USER_ROLE {
  RM = 'RM',
  STUDENT = 'STUDENT',
  PARTNER = 'PARTNER',
  ADMIN = 'COMMUNITYADMIN',
}

export const ROLE_DISPLAY_NAME: { [key in USER_ROLE]: string } = {
  [USER_ROLE.RM]: 'RM',
  [USER_ROLE.STUDENT]: 'Student',
  [USER_ROLE.PARTNER]: 'Partner',
  [USER_ROLE.ADMIN]: 'Admin',
};

export const VERIFIED_USER_ROLES = [USER_ROLE.RM, USER_ROLE.ADMIN];
